export default __webpack_public_path__ + "static/media/choose_from_lib.e523633c.png";